import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { eocChangeboardingLayout } from '@jira/platform__layouts-eoc-changeboarding-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { whoIsOnCallRoute } from '@jira/router-routes__eoc-who-is-on-call-routes/src/whoIsOnCallRoute.tsx';
import { resources as whoIsOnCallResources } from '@atlassian/eoc-who-is-on-call/resources';
import type { Route, RouteResources } from '@atlassian/react-resource-router';
import { WhoIsOnCallComponent, LazyWhoIsOnCall } from './ui/WhoIsOnCallComponent.tsx';

const getWhoIsOnCallResources = () => whoIsOnCallResources;

export const whoIsOnCallRouteEntry: Route = createEntry(whoIsOnCallRoute, () => ({
	group: 'eoc',
	layout: eocChangeboardingLayout,
	// eslint-disable-next-line no-restricted-syntax
	component: WhoIsOnCallComponent,

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	resources: [
		...getNavigationResources(),
		getConsolidationStateResource(),
		...getWhoIsOnCallResources(),
	] as RouteResources,

	forPaint: [LazyAtlassianNavigation, LazyWhoIsOnCall],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
